<div class="hold-transition skin-blue layout-top-nav">
    <div class="wrapper">
        <footer class="main-footer">
            <div class="container-fluid text-center" *ngIf="domainname == 'normandy'" >
                <div class="pull-right hidden-xs">
                    
                </div>
                <strong>Copyright © {{year}} Normandy Insurance Services</strong> All rights reserved.
            </div>
            <div class="container-fluid text-center" *ngIf="domainname == 'boldpenguin'" >
                <div class="pull-right hidden-xs">
                    
                </div>
                <strong>Copyright © {{year}} Bold Penguin Inc.</strong> All rights reserved.
            </div>

            <div class="container-fluid text-center" style="background-color:#000000; color:#fff; padding:6px 0!important; margin:0!important; min-height:auto!important; height:auto!important; line-height:1.3!important; text-align:center;" *ngIf="domainname == 'everiskpro'" >
                <div class="pull-right hidden-xs">
                </div>
                <span style="font-size:13px; line-height:1.3;">© <strong>Everisk Insurance Programs</strong> | Powered by <a href="https://www.evolveitnow.com" target="_blank" style="color:#fff">Evolve Business Solutions</a></span>
            </div>
            <div *ngIf="domainname == 'everiskpro'" style="margin:0!important; padding:0!important;">
                <a href="https://www.s-sols.com/products/wordpress/accelerator?utm_source=usersite&amp;utm_medium=banner&amp;utm_campaign=free_lim_ver&amp;utm_term=accel" target="_blank" style="display:block!important;clear:both!important;text-align:center!important;position:relative!important;padding:0.3em 0.5em!important;margin:0!important;background-color:transparent!important;color:#000!important;line-height:1!important;"><img src="assets/images/seraphinite-icon.png" alt="Seraphinite Accelerator" style="display:inline-block!important;vertical-align:top!important;position:absolute!important;width:auto!important;height:auto!important;"><span style="display:inline-block!important;text-align:left!important;vertical-align:top!important;font-size:14px!important;padding-left:36px!important;">Optimized by Seraphinite Accelerator<br><span style="font-size:0.7em!important;">Turns on site high speed to be attractive for people and search engines.</span></span></a>
            </div>
            
            <div class="container-fluid text-center" *ngIf="domainname == 'canopy'" >
                <div class="pull-right hidden-xs">
                    
                </div>
                <strong>Copyright © {{year}} Canopy Specialty Insurance LLC</strong> All rights reserved.
            </div>
            <div class="container-fluid text-center" *ngIf="domainname == 'pbibins'" >
                <div class="pull-right hidden-xs">
                   
                </div>
                <strong>Copyright © {{year}} Pascal Burke Insurance POWERED BY Jaspar Technologies LLC.</strong> All rights reserved.Privacy Policy and Terms of Use.
            </div>
            <div class="container-fluid text-center" *ngIf="domainname == ''" >
                <div class="pull-right hidden-xs">
                    
                </div>
                <strong >Copyright © {{year}} Shield Commercial Insurance Services, Inc.</strong> All rights reserved.
                <div class="row">
                    <div class="container-fluid text-center">
                        <button type="button" class="btn btn-sm btn-info" style="padding-left: 20px; padding-right: 20px;" (click)="openDoc(1)">Privacy Policy</button>
                        <button type="button" class="btn btn-sm btn-info" style="padding-left: 20px; padding-right: 20px;" (click)="openDoc(2)">Privacy Terms</button>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>